// React imports
import React from 'react';

// Third-party imports
import clsx from 'clsx';
import { faBan, faCheckCircle, faEye, faPen } from '@fortawesome/pro-regular-svg-icons';

// Types
import { Discount } from '../types';

// UI Components
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import ThreeDotsDropdown from 'components/UI/V3/ThreeDotsDropdown';

// Styles
import styles from './DiscountsRow.module.scss';

interface DiscountsRowProps {
    discount: Discount;
    isLast: boolean;
    onView: (id: number) => void;
    onEdit: (id: number) => void;
    onToggleStatus: (id: number) => void;
    onDelete: (id: number) => void;
    isDropdownOpen?: boolean;
    onDropdownToggle?: (isOpen: boolean) => void;
}

export const DiscountsRow: React.FC<DiscountsRowProps> = ({
    discount,
    isLast,
    onEdit,
    onView,
    onToggleStatus,
    onDelete,
    isDropdownOpen = false,
    onDropdownToggle
}) => {
    const editOption = {
        id: 'edit',
        label: 'Edit',
        icon: faPen,
        onClick: () => onEdit(discount.id)
    };
    const toggleStatusOption = {
        id: 'toggle-status',
        label: discount.isActive ? 'Deactivate' : 'Activate',
        icon: discount.isActive ? faBan : faCheckCircle,
        onClick: () => onToggleStatus(discount.id)
    };
    const viewOption = {
        id: 'view',
        label: 'View',
        icon: faEye,
        onClick: () => onView(discount.id)
    };

    const options = (discount: Discount) => {
        switch (discount.used > 0) {
            case true:
                return [viewOption, toggleStatusOption];
            case false:
                return [viewOption, editOption, toggleStatusOption /* , deleteOption */];
        }
    };

    return (
        <TableRow className={styles.row}>
            <TableCell>{discount.name}</TableCell>
            <TableCell>{discount.type}</TableCell>
            <TableCell>
                {discount.businessAreaCounts.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {discount.businessAreaCounts.map((item, index) => (
                            <div key={index}>{item.displayLabel}</div>
                        ))}
                    </div>
                ) : (
                    <span>{discount.services}</span>
                )}
            </TableCell>
            <TableCell>{discount.applyTo}</TableCell>
            <TableCell>{discount.used}</TableCell>
            <TableCell
                isActions
                onClick={() => {
                    onDropdownToggle?.(!isDropdownOpen);
                }}
            >
                <ThreeDotsDropdown
                    direction={isLast ? 'up' : 'down'}
                    options={options(discount)}
                />
            </TableCell>
        </TableRow>
    );
};
